/** 통계 API wrapper. */

import { apiClient } from "./client";

export interface StatsTodayOut {
  job_count: number;
  processed_count: number;
  success_count: number;
  rejected_count: number;
  error_count: number;
}

export async function getStatsToday(): Promise<StatsTodayOut> {
  const res = await apiClient.get<StatsTodayOut>("/stats/today");
  return res.data;
}
